const CITIES = [
  { label: 'NEW YORK, USA',    tz: 'America/New_York' },
  { label: 'LISBON, PORTUGAL', tz: 'Europe/Lisbon' },
  { label: 'BERLIN, GERMANY',  tz: 'Europe/Berlin' },
  { label: 'TOKYO, JAPAN',     tz: 'Asia/Tokyo' },
];

const CYCLE_MS = 4000;

export function initClock() {
  const cityEl = document.querySelector('[data-clock-city]');
  const timeEl = document.querySelector('[data-clock-time]');
  if (!cityEl || !timeEl) return;

  let idx = 0;

  function tick() {
    const { label, tz } = CITIES[idx];
    const now = new Date();
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    });
    timeEl.textContent = fmt.format(now);
    cityEl.textContent = label;
  }

  function cycle() {
    cityEl.classList.add('is-out');
    timeEl.classList.add('is-out');
    setTimeout(() => {
      idx = (idx + 1) % CITIES.length;
      tick();
      cityEl.classList.remove('is-out');
      timeEl.classList.remove('is-out');
    }, 280);
  }

  tick();
  setInterval(tick, 1000);
  setInterval(cycle, CYCLE_MS);
}
